import {
  IUIPage,
  UIUrvalConditionObjectType,
  ITypeTreeConditionObject,
} from 'src/Types/UrvalTypes';
import { update, uniq } from 'ramda';
import {
  set,
  conditionObjectHasValue,
} from '../../Condition/Utils/UrvalConditionObjectUtils';
import { getValidInComponents } from '../../Condition/Components/TypeTreePicker/Utils/typeConditionUtils';
import { ITypeConditionInfo } from '../../../Utils/urvalUtils';

export const setConditionObject = (
  index: number,
  newConditionObject: UIUrvalConditionObjectType,
  page: IUIPage
): IUIPage => {
  const newConditionObjects = update(
    index,
    newConditionObject,
    page.conditionObjects
  );

  const newPage = set('conditionObjects', newConditionObjects, page);

  return newPage;
};

/** Updates type condition object on sida if conditionObject has changed */
export const updateTypeConditionObject = (
  sida: IUIPage,
  oldConditionObject: UIUrvalConditionObjectType,
  newConditionObject: UIUrvalConditionObjectType,
  typeConditionInfo: ITypeConditionInfo | undefined
): IUIPage => {
  const validInComps = getValidInComponents(newConditionObject);

  if (validInComps.length > 0 && typeConditionInfo) {
    if (
      !conditionObjectHasValue(oldConditionObject) &&
      conditionObjectHasValue(newConditionObject)
    ) {
      const newImplicitCondition = uniq(
        typeConditionInfo.object.implicitCondition.concat(validInComps)
      );
      const newTypeConditionObject: ITypeTreeConditionObject = {
        ...typeConditionInfo.object,
        implicitCondition: newImplicitCondition,
      };
      sida = setConditionObject(
        typeConditionInfo.index,
        newTypeConditionObject,
        sida
      );
    } else if (
      conditionObjectHasValue(oldConditionObject) &&
      !conditionObjectHasValue(newConditionObject)
    ) {
      const newImplicitCondition =
        typeConditionInfo.object.implicitCondition.filter(
          condition => !validInComps.includes(condition)
        );
      const newTypeConditionObject: ITypeTreeConditionObject = {
        ...typeConditionInfo.object,
        implicitCondition: newImplicitCondition,
      };
      sida = setConditionObject(
        typeConditionInfo.index,
        newTypeConditionObject,
        sida
      );
    }
  }

  return sida;
};
